var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-form-page-break q-form-builder-element"},[(_vm.label)?_c('label',[_c('strong',[_vm._v("Page Break: ")]),_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('q-separator',{attrs:{"spaced":"","color":"primary"}}),(_vm.hint)?_c('p',{staticClass:"text-caption",domProps:{"innerHTML":_vm._s(_vm.hint)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }